import React from 'react';
import { Receipt, Inbox, Archive, AlertTriangle, FileWarning, Clock } from 'lucide-react';

const CARDS = [
  {
    icon: Inbox,
    title: 'The March pile doubles weekly',
    body:
      'February: 12 client folders, mostly organized. March: every client emails or uploads a fresh stack of receipts and 1099s every week. By mid-March your downloads folder has 1,400 unfiled PDFs and you cannot tell which client a scan_047.pdf belongs to without opening it.',
  },
  {
    icon: Receipt,
    title: 'Receipts named receipt(7).pdf and statement.pdf',
    body:
      'Clients forward e-receipts from email, download statements from a dozen portals, and dump everything into one folder. None of those names tell you the vendor, amount, or date. Manual rename is 15 seconds per file; on 800 receipts that is over three hours per client.',
  },
  {
    icon: FileWarning,
    title: '1099-NEC, 1099-INT, K-1, W-2 all in one folder',
    body:
      'A client sends a zip with twelve 1099 forms, three K-1s from partnerships, and a stack of brokerage 1099-DIVs. They are all named "1099.pdf" or "Form-1099.pdf" with a number on the end. Sorting them by issuer and account takes longer than entering them.',
  },
  {
    icon: AlertTriangle,
    title: 'Receipts misfiled to the wrong client',
    body:
      'You file an Uber receipt under client A. It actually belongs to client B (different business). At quarter close you reconcile and find the discrepancy. Now you are scrubbing back through a month of receipts to find anything else that may have ended up in the wrong place.',
  },
  {
    icon: Archive,
    title: 'Year-end archive prep is a manual slog',
    body:
      'When you close out 2025 work, you want to lock 2025 working files and start 2026 fresh. In practice that is hours of dragging folders, renaming archives, and verifying nothing got left behind. The Downloads folder of last-minute statements gets archived as one undifferentiated lump.',
  },
  {
    icon: Clock,
    title: 'Multi-year amendments need yesterday\'s structure',
    body:
      'A client gets a CP2000 notice for 2023. You need that year\'s clean folder, with the brokerage statements, K-1s, and receipts in their original layout. If the 2023 archive is messy you spend an hour reconstructing what the file pile looked like before you can answer the IRS letter.',
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          The accounting filing problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Six patterns we hear from every CPA, EA, and bookkeeping shop we talk to. Every one of
          them gets worse the closer you get to a filing deadline.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
